import { ILop } from "../../../model/respone/category/ILop";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eLopActionTypeIds {
    LOAD_START = "LOP_LOAD_START",
    LOAD_SUCCESS = "LOP_LOAD_SUCCESS",
    LOAD_ERROR = "LOP_LOAD_ERROR"
}
export interface ILopLoadStart extends IActionTypeBase<eLopActionTypeIds.LOAD_START, undefined> { }
export interface ILopLoadSuccess extends IActionTypeBase<eLopActionTypeIds.LOAD_SUCCESS, ILop[]> { }
export interface ILopLoadError extends IActionTypeBase<eLopActionTypeIds.LOAD_ERROR, string | undefined> { }

export type ILopActionTypes = ILopLoadStart | ILopLoadSuccess | ILopLoadError